import { createSlice } from "@reduxjs/toolkit";
import { expenseManagementReducer } from "./reducer";
import {
  addEmployeeExpenseAction,
  getAllEmployeeExpnsesAction,
  initialState,
  updateEmployeeExpenseAction,
} from ".";
import { ExpenseManagementTypes } from "./expenseManagementTypes";

export const expenseManagementSlice = createSlice({
  name: "expenseManagement",
  initialState,
  reducers: expenseManagementReducer,
  extraReducers(builder) {
    builder
      .addCase(
        addEmployeeExpenseAction.pending,
        (state: ExpenseManagementTypes) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        addEmployeeExpenseAction.fulfilled,
        (state: ExpenseManagementTypes, { payload }) => {
          const { status_code, success, result, message } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            success,
          };
        }
      )
      .addCase(
        addEmployeeExpenseAction.rejected,
        (state: ExpenseManagementTypes, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(
        updateEmployeeExpenseAction.pending,
        (state: ExpenseManagementTypes) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        updateEmployeeExpenseAction.fulfilled,
        (state: ExpenseManagementTypes, { payload }) => {
          const { status_code, success, message } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              statusCode: status_code,
              error: message,
            };
          }

          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
          };
        }
      )
      .addCase(
        updateEmployeeExpenseAction.rejected,
        (state: ExpenseManagementTypes, { error }) => ({
          ...state,
          fetching: false,
          success: 0,
          error: error?.message,
        })
      )
      .addCase(
        getAllEmployeeExpnsesAction.pending,
        (state: ExpenseManagementTypes) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        getAllEmployeeExpnsesAction.fulfilled,
        (state: ExpenseManagementTypes, { payload }) => {
          const { success, result, message, status_code } = payload;

          if (success === 0) {
            return {
              ...state,
              fetching: false,
              success,
              error: message,
              statusCode: status_code,
            };
          }

          return {
            ...state,
            fetching: false,
            success,
            statusCode: status_code,
          };
        }
      )
      .addCase(
        getAllEmployeeExpnsesAction.rejected,
        (state: ExpenseManagementTypes, { error }) => ({
          ...state,
          fetching: false,
          success: 0,
          error: error?.message,
        })
      );
  },
});

export const {
  resetExpenseManagementError,
  resetExpenseManagementFetching,
  resetExpenseManagementStatusCode,
  resetExpenseManagementSuccess,
} = expenseManagementSlice.actions;
